/* eslint-disable prefer-promise-reject-errors */
import { message } from 'antd';
import { history } from 'umi';
import { generateLoginUrl } from '@/utils/utils';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import axios from 'axios';

// key => expired
// 根据 text 节流的 message 方法
const cache = new Map();
const showErrorMessage = text => {
  const expiredTime = cache.get(text);
  if (!expiredTime || expiredTime < +new Date()) {
    cache.set(text, +new Date() + 3000);
    message.error(text);
  }
};

// 存在错误和错误信息时进行抛错提示
const isErrorMsg = response => {
  const errCode = response.data?.errorcode ?? response.data?.err_no;

  // 当存在数据，且大于0时表示接口异常
  if (errCode && errCode > 0) {
    // 异常时错误提示
    const msg = response.data?.errormessage ?? response.data?.err_msg;
    showErrorMessage(msg);
    return true;
  }
  // 有些接口不返回errCode，那么表示是正常
  return false;
};

export default request => {
  // 请求拦截
  request.interceptors.request.use(
    config => config,
    error => Promise.reject(error)
  );
  request.interceptors.response.use(
    response => {
      if (isErrorMsg(response)) {
        return Promise.reject(response);
      }

      return response;
    },
    error => {
      if (axios.isCancel(error)) {
        // console.log(`请求被取消`, error.message);
        return Promise.reject(error.message);
      }

      if (!error.response) {
        showErrorMessage(error.message || '请求异常!');
        history.push('/exception/500');
        return Promise.reject({});
      }
      switch (error.response.status) {
        case 429: {
          history.push('/exception/429');
          break;
        }
        case 403: {
          history.push('/exception/403');
          break;
        }
        case 404: {
          showErrorMessage('请求的接口不存在!');
          break;
        }
        case 401: {
          // 跳到登录页面
          window.location.href = generateLoginUrl(window.location.origin);
          break;
        }
        // 422状态错误单独处理
        case 422: {
          if (isString(error.response.data)) {
            showErrorMessage(error.response.data);
            break;
          }

          const data = error.response.data.errors;
          let content = '';
          if (isObject(data)) {
            Object.keys(data).forEach(key => {
              const value = data[key];
              [content] = value;
            });
            showErrorMessage(content);
            break;
          }

          if (error.response.data.errormessage) {
            showErrorMessage(error.response.data.errormessage);
          }

          break;
        }
        case 500:
        case 501:
        case 503:
          message.error('服务器出了点小问题~！');
          break;
        case 400:
        default:
          isErrorMsg(error.response);
          break;
      }

      return Promise.reject(error.response);
    }
  );
};
